import { ConstantContactCustomField } from "./constant-contact-custom-field";
import { ConstantContactEmailAddressPost } from "./constant-contact-email-address-post";
import { ConstantContactPhoneNumberPut } from "./constant-contact-phone-number-put";
import { ConstantContactStreetAddressPut } from "./constant-contact-street-address-put";

export class ConstantContactContactPostRequest {

    constructor(
        public emailAddress: ConstantContactEmailAddressPost,
        public firstName: string,
        public lastName: string,
        public jobTitle: string | null,
        public companyName: string | null,
        public createSource: string,
        public birthdayMonth: number | null,
        public birthdayDay: number | null,
        public anniversary: string | null,
        public customFields: ConstantContactCustomField[],
        public phoneNumbers: ConstantContactPhoneNumberPut[],
        public streetAddresses: ConstantContactStreetAddressPut[],
        public listMemberships: string[],
        public taggings: string[]
    ){}
}
